<template>
  <v-card flat>
      <v-card-text>
        <v-toolbar flat>
          <v-toolbar-title>
            Resources
            <v-chip small>
              {{ resources.length||0 }}
            </v-chip>
          </v-toolbar-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-search"
            label="Search"
            single-line
            hide-details
            class="mx-5"
          ></v-text-field>
          <base-admin-dialog 
            title="Resource"
            v-model="dialog" 
            :id="editedItem.objectId"
            :save="save"
            :close="close"
            :form-title="formTitle">
            <template #form>
              <v-container grid-list-md class="pa-1">
                <v-layout wrap>
                  <v-flex xs12 sm4>
                    <v-text-field v-model="editedItem.Name" label="Name"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm8>
                    <v-text-field v-model="editedItem.Short" label="Short"></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-textarea v-model="editedItem.Full" auto-grow label="Description"></v-textarea>
                  </v-flex>
                  <v-flex xs12 sm2>
                      <v-text-field v-model="editedItem.RemoteId" label="Airbnb Id"></v-text-field>
                      <v-btn
                        fab
                        v-if="editedItem.RemoteId"
                        @click="loadAirbnb(editedItem.RemoteId)">
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                  </v-flex>
                  <v-flex xs12 sm3>
                    <v-text-field :value="userPointer" label="User"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm2>
                    <v-text-field readonly v-model="editedItem.Views" label="Views"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm2>
                    <v-text-field readonly v-model="editedItem.Votes" label="Votes"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm3>
                    <v-text-field :value="editedItem.State" label="State"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm3>
                    <v-text-field :value="editedItem.Category" label="Category"></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    Images 
                    <v-btn x-small @click="fetchImages(editedItem.RemoteId,editedItem.id)">
                      Fetch {{ editedItem.id }}
                    </v-btn>
                    <v-row>
                      <v-col
                        v-for="(t,i) in editedItem.ImgThumb"
                        :key="i"
                      >
                        <v-img
                        :src="t.url"
                        :max-width="150"
                        :max-height="50" />
                      </v-col>
                    </v-row>
                  </v-flex>
                </v-layout>
              </v-container>
            </template>
          </base-admin-dialog>
        </v-toolbar>
        <base-admin-table
          :items="resources"
          :items-per-page="20"
          :sort-by="'DateCreated'"
          :sort-desc="true"
          :headers="headers"
          :search="search"
          :loading="loading">
          <template #item="props">
            <tr>
              <td>
                <span class="text-truncate" :title="props.item.id">
                {{ (props.item.Name||'').substr(0,30) }}
                </span>
              </td>
              <td>
                <v-img class="text-truncate"
                  contain
                  v-if="props.item.ImgThumb"
                  max-height="50"
                  max-width="150"
                  :src="props.item.ImgThumb[0].url"
                />
              </td>
              <td>
                <span class="text-truncate">
                {{ (props.item.Short||'').substr(0,40) }}..
                </span>
              </td>
              <td class="text-center">{{ props.item.DateCreated | asDate }}</td>
              <td class="text-truncate">{{ props.item.State }}</td>
              <td class="text-center">{{ props.item.Votes }}</td>
              <td>
                <div class="d-flex">
                  <v-switch
                    v-model="props.item.Approved"
                    class="mx-auto"
                  >
                  </v-switch>
                </div>
              </td>
              <td class="text-no-wrap text-right">
                <v-icon
                  small
                  class="mr-2"
                  @click="editItem(props.item)">
                  mdi-pencil
                </v-icon>
                <v-icon
                  small
                  @click="deleteItem(props.item)">
                  mdi-delete
                </v-icon>
              </td>
            </tr>
          </template>
        </base-admin-table>
        <v-btn @click="getResources">
          Load More
        </v-btn>
      </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { GET_RESOURCES, UPDATE_RESOURCE, SAVE_RESOURCE, DELETE_RESOURCE, GET_RESOURCE_MORE_IMAGES } from '@/store/action-types'
import { SET_RESOURCE } from '@/store/mutation-types'
import { BaseAdminTable, BaseAdminDialog } from '@/components/core'
import { copyToClipboard, formatDate } from '@/util/utils'

export default {
  name: 'AdminResources',
  components: {
    BaseAdminTable,
    BaseAdminDialog,
  },
  data() {
    return {
      dialog: false,
      search: '',
      headers: [
        { text: 'Name', value:'Name', class:"text-truncate"},
        { text: 'Thumb', value:'ImgThumb[0].url', width: '100px'},
        { text: 'Short', value: 'Short', class:"text-truncate"},
        { text: 'Added', value:'DateCreated', align:'center', class:"text-truncate"},
        { text: 'State', value:'State', align:'center', class:"text-truncate"},
        { text: 'Votes', value:'Votes', align:'center', class:"text-truncate"},
        { text: 'Approved', value:'Approved', align:'center', class:"text-center"},
        { text: 'Actions', value:'id', align:'right', class:"text-truncate", sortable:false }
      ],
      activeIndex: -1,
      defaultItem: {
        name: '',
        description: null,
      },
      editedItem: {},
      pagination: {
        rowsPerPage: 10,
        sortBy: 'DateCreated',
        descending: true
      },
    }
  },
  async created () {
    await this.getResources()
  },
  computed: {
    ...mapState({
      resources: state => state.resource.all,
      activeResource: state => state.resource.resource,
      loading: state => state.resource.isLoading
    }),
    ...mapGetters([
      'getUserPointer'
    ]),
    formTitle () {
      return this.activeIndex === -1 ? 'New Resource' : 'Edit Resource'
    },
    userPointer() {
      if (this.activeResource && this.activeResource.userId) {
        return this.activeResource.userId.objectId
      }
      else {
        return null
      }
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  filters: {
      asDate: formatDate
  },
  props: {},
  methods: {
    copyToClipboard,
    getResources() {
      this.$store.dispatch(GET_RESOURCES)
    },
    editItem(item) {
      this.activeIndex = this.resources.indexOf(item)
      this.editedItem = {
        ...this.editedItem,
        ...item
      }
      this.$store.commit(SET_RESOURCE, this.editedItem)
      this.dialog = true
    },
    deleteItem(item) {
      const index = this.resources.indexOf(item)
      confirm('Are you sure you want to delete this?') && this.resources.splice(index, 1)
      this.$store.dispatch(DELETE_RESOURCE, item.objectId)
    },
    close() {
      this.dialog = false
      setTimeout(() => {
        this.$store.commit(SET_RESOURCE, this.defaultItem)
        this.activeIndex = -1
      }, 300)
    },
    save() {
      if (this.activeIndex > -1 && this.activeResource.objectId) {
        // update in db
        this.$store.dispatch(UPDATE_RESOURCE, this.activeResource)
      } else {
        // create in db
        this.$store.dispatch(SAVE_RESOURCE, this.activeResource)
      }
      // update libraries array
      this.$store.commit(SET_RESOURCE, this.activeResource)
      this.close()
    },
    fetchImages(id, recId) {
      this.$store.dispatch(GET_RESOURCE_MORE_IMAGES, { id, recId })
    },
    loadAirbnb(airbnbId) {
      console.log(airbnbId)
      this.$store.dispatch('LOAD_RESOURCE', { remoteId: airbnbId, type: 'airbnb' })
    }
  }
}
</script>
